'use strict'
import { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Typography
} from '@material-ui/core'

export default function CreateScenarioModal ({ open, onClose, scenarios, selectedScenarioId, onSubmit }) {
  const [name, setName] = useState('')
  const [horizonDays, setHorizonDays] = useState(30)
  const [seedMode, setSeedMode] = useState('live')

  const handleSubmit = () => {
    onSubmit({
      name: name.trim() || undefined,
      horizonDays,
      sourceScenarioId: seedMode !== 'live' && seedMode !== 'locked_only' ? seedMode : undefined,
      seedMode: seedMode === 'locked_only' ? 'locked_only' : undefined
    })
  }

  const handleEnter = () => {
    setName('')
    setHorizonDays(30)
    setSeedMode(selectedScenarioId || 'live')
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth onEnter={handleEnter}>
      <DialogTitle style={{ borderBottom: '1px solid var(--df-line)', paddingBottom: 12, fontWeight: 700 }}>
        Create New Scenario
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" style={{ gap: 16, paddingTop: 16 }}>
          <TextField
            label="Scenario Name"
            variant="outlined"
            size="small"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Spring 2026 Rebalance"
            autoFocus
          />
          <TextField
            label="Horizon Days"
            variant="outlined"
            size="small"
            type="number"
            fullWidth
            value={horizonDays}
            onChange={(e) => setHorizonDays(parseInt(e.target.value, 10) || 30)}
            inputProps={{ min: 7, max: 365 }}
          />
          <FormControl variant="outlined" size="small" fullWidth>
            <InputLabel>Starting Point</InputLabel>
            <Select
              value={seedMode}
              onChange={(e) => setSeedMode(e.target.value)}
              label="Starting Point"
            >
              <MenuItem value="live">Live assignments (keep all current)</MenuItem>
              <MenuItem value="locked_only">Locked only (clear non-locked)</MenuItem>
              {(scenarios || []).map(s => (
                <MenuItem key={s._id} value={s._id}>{s.name} ({s.status})</MenuItem>
              ))}
            </Select>
          </FormControl>
          {seedMode === 'locked_only' && (
            <Typography variant="caption" style={{ color: 'var(--df-accent)' }}>
              All non-locked properties will start unassigned. Only locked crew assignments are kept.
            </Typography>
          )}
          <Typography variant="caption" style={{ color: 'var(--df-ink-3)' }}>
            A draft scenario lets you experiment with territory assignments without affecting live routing.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions style={{ borderTop: '1px solid var(--df-line)', padding: '12px 24px' }}>
        <Button onClick={onClose} style={{ color: 'var(--df-ink-2)' }}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}
          style={{ background: 'var(--df-primary)', color: '#fff' }}>
          Create Draft
        </Button>
      </DialogActions>
    </Dialog>
  )
}
